import { getAlertsAPIConfig } from './alert.config';

const GET_ALERTS_REQUEST_CALLED = 'GET_ALERTS_REQUEST_CALLED';
export const HANDLE_GET_ALERTS = 'HANDLE_GET_ALERTS';
const GET_ALERTS_REQUEST_SUCCEEDED = 'GET_ALERTS_REQUEST_SUCCEEDED';
const GET_ALERTS_REQUEST_FAILED = 'GET_ALERTS_REQUEST_FAILED';

const SET_ALERT = 'SET_ALERT';

export const handleGetAlerts = params => ({
    type: HANDLE_GET_ALERTS,
    payload: {
        params,
    },
});

export const getAlerts = params => ({
    type: GET_ALERTS_REQUEST_CALLED,
    actionTypes: {
        success: GET_ALERTS_REQUEST_SUCCEEDED,
        fail: GET_ALERTS_REQUEST_FAILED,
    },
    config: getAlertsAPIConfig(params),
});

export const setAlert = message => ({
    type: SET_ALERT,
    payload: {
        message,
    },
});

const initialState = {
    loadState: 'loading',
    data: {},
    error: null,
};

export const alertsReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_ALERTS_REQUEST_CALLED:
        return {
            ...state,
            loadState: 'loading',
            data: {},
            error: null,
        };
    case GET_ALERTS_REQUEST_SUCCEEDED:
        return {
            ...state,
            loadState: 'success',
            data: action.payload.data,
            error: null,
        };
    case GET_ALERTS_REQUEST_FAILED:
        return {
            ...state,
            loadState: 'fail',
            data: {},
            error: action.payload,
        };
    case SET_ALERT:
        return {
            ...state,
            loadState: 'idle',
            data: {
                message: action.payload.message,
            },
        };

    default:
        return state;
    }
};
